export const ADD_TOAST = 'ADD_TOAST';
export const ADD_MULTIPLE_TOASTS = 'ADD_MULTIPLE_TOASTS';
export const ADD_CUSTOM_TOAST = 'ADD_CUSTOM_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const REMOVE_TOASTS = 'REMOVE_TOASTS';
